import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Button, Result } from 'antd';
import { useSelector } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import SignUp from "../Authentication/SignUp";
import DashboardLayout from "../layout/DashboardLayout";
import FileUploadAndProcessForm from "../components/DataUpload/FileUploadAndProcessForm";
import DataReviewAndConfigure from "../components/DataHistory/DataReviewAndConfigure";
import WelcomeDashboard from "../components/Dashboard/WelcomeDashboard";
import Login from "../Authentication/Login";
import ForgotPassword from "../Authentication/ForgotPassword";
import EmailVerificationPage from "../Authentication/EmailVerificationPage";
import PhoneVerificationPage from "../Authentication/PhoneVerificationPage";
import Help from "../Authentication/Help";
import AnalyticsDashboard from "../components/DataHistory/AnalyticsDashboard";
import LandingPage from "../pages/LandingPage";
import AboutUs from "../pages/AboutUs";
import Security from "../pages/Security";
import UseCase from "../pages/UseCase";
import Pricing from "../pages/Pricing";
import ContactUs from "../pages/ContactUs";
import TermsOfUse from "../pages/TermsOfUse";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import UserHistoryDashboard from "../components/Dashboard/UserHistoryDashboard";


function PrivateRoute({ children }) {
  const location = useLocation();
  const { isLoggedIn, accessToken, refreshToken, googleAccessToken, linkedInAccessToken } = useSelector((state) => state.auth);
  const isAuthorized = Boolean(isLoggedIn && (accessToken || refreshToken|| googleAccessToken || linkedInAccessToken));
  
  if (!isAuthorized) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
 
  return children;
}

function PublicRoute({ children }) {
  const { isLoggedIn, accessToken, refreshToken, googleAccessToken, linkedInAccessToken } = useSelector((state) => state.auth);
  const isAuthorized = Boolean(isLoggedIn && (accessToken || refreshToken || googleAccessToken || linkedInAccessToken));
 
  if (isAuthorized) {
    return <Navigate to="/dashboard" replace />;
  }
 
  return children;
}

const AppRoutes = () => {
   const navigate = useNavigate();
   const applyResponse = useSelector((s) => s.file?.applyResponse);

   const GOOGLE_CLIENT_ID =  process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Routes>
      {/* Public */}
      <Route index element={<PublicRoute><LandingPage /></PublicRoute>} />
      <Route path="/use-case" element={<UseCase />} />
      <Route path="/security" element={<Security />} /> 
      <Route path="/about" element={<AboutUs />} /> 
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/login/help" element={<Help />} />
      <Route path="/signup" element={<PublicRoute><SignUp /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
      <Route path="/verify-email" element={<PublicRoute><EmailVerificationPage /></PublicRoute>} />
      <Route path="/verify-phone" element={<PublicRoute><PhoneVerificationPage /></PublicRoute>} />

      {/* Protected layout with nested routes */}
      <Route
        path="/dashboard/*"
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        {/* index = /dashboard */}
        <Route index element={<WelcomeDashboard />} />
        {/* /dashboard/data-entry */}
        <Route path="data-entry" element={<FileUploadAndProcessForm />} />
        {/* /dashboard/anamoly-detection */}
        <Route path="anamoly-detection" element={<DataReviewAndConfigure />} />
        {/* /dashboard/anamoly-detection/analytic-dashboard */}
        <Route path="anamoly-detection/analytic-dashboard" element={<AnalyticsDashboard applyResponse={applyResponse} />} />
        {/* /dashboard/data-history */}
        <Route path="data-history" element={<UserHistoryDashboard />} />
        {/* /dashboard/subscription */}
        <Route path="subscription" element={<Pricing isInDashboard={true} />} />
        {/* /dashboard/use-case */}
        <Route path="use-case" element={<UseCase isInDashboard={true} />} />
        {/* /dashboard/contact-us */}
        <Route path="contact-us" element={<ContactUs isInDashboard={true} />} />
      </Route>

      {/* 404 */}
      <Route
        path="*"
        element={
          <Result
            className="!bg-transparent"
            status="404"
            title={<span className="!text-white">404</span>}
            subTitle={<span className="!text-white text-lg">Sorry, the page you visited does not exist.</span>}
            extra={<button className="font-semibold text-[#cca1e4] hover:text-[#bd9bd1] transition-colors text-lg border border-[#bd9bd1] px-4 py-2 rounded-lg" onClick={() => navigate("/")} type="button">Back Home</button>}
          />
        }
      />
    </Routes>
    </GoogleOAuthProvider>
  );
};

export default AppRoutes;
